import React from "react";

/**
 * Full-bleed page hero with image, scrim, large serif title, optional subtitle,
 * and an ochre accent rule. Used on inner pages.
 */
export default function PageHero({ image, title, subtitle, testId = "page-hero", height = "tall" }) {
  const heightCls = height === "short"
    ? "h-[44vh] min-h-[320px] md:h-[52vh]"
    : "h-[60vh] min-h-[420px] md:h-[68vh]";
  return (
    <section
      data-testid={testId}
      className={`relative w-full ${heightCls} overflow-hidden`}
    >
      <img src={image} alt="" className="absolute inset-0 w-full h-full object-cover" />
      <div className="absolute inset-0 hero-scrim-soft" />
      <div className="relative h-full max-w-[1600px] mx-auto px-6 md:px-10 lg:px-14 flex flex-col justify-end pb-12 md:pb-20 pt-32">
        <h1
          data-testid={`${testId}-title`}
          className="font-serif text-white text-5xl md:text-7xl lg:text-8xl leading-[0.95] tracking-tight rise-in"
        >
          {title}
        </h1>
        <hr className="accent-rule mt-6 rise-in rise-delay-1" />
        {subtitle && (
          <p
            data-testid={`${testId}-subtitle`}
            className="text-[#f7f4ec] text-lg md:text-2xl mt-6 max-w-2xl font-light leading-relaxed rise-in rise-delay-2"
          >
            {subtitle}
          </p>
        )}
      </div>
    </section>
  );
}
